import { ref, onMounted, onUnmounted } from "vue";

export function useWindowHeight() {
    const windowHeight = ref<number>(window.innerHeight);

    const updateWindowHeight = (): void => {
        windowHeight.value = window.innerHeight;
    };

    onMounted(() => {
        updateWindowHeight();
        window.addEventListener("resize", updateWindowHeight);
    });

    onUnmounted(() => {
        window.removeEventListener("resize", updateWindowHeight);
    });

    return { windowHeight };
}
